import React, {forwardRef, useImperativeHandle, useState} from "react";
import {IconClose} from "../../Icon";
import {t} from "i18next";
import {Modal,Button} from "antd";
import {getImagePath} from "@/utils";
import {MAX_Z_INDEX} from "@/Const";

const DialogOtherTip = forwardRef((props, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);

    const onShowDialog = ()=>{
        setIsShowDialog(true);
    }

    return(
        <Modal width={460} zIndex={MAX_Z_INDEX}
               open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null} onCancel={()=> {
            setIsShowDialog(false);
        }}>
            <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
                <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                    <span className={'dialog-title'}>{t("Tips")}</span>
                    <div style={{flexGrow: '1'}}/>
                </div>
                <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

                <span className={'mt-6'} style={{color: 'var(--color-666666)'}}>{t("CloudToast1")}</span>
                <span className={'mt-12'} style={{color: 'var(--color-666666)'}}>{t("CloudToast2")}</span>
                <span className={'mt-12'} style={{color: 'var(--color-666666)'}}>{t("CloudToast3")}</span>
                <span className={'mt-12'} style={{color: 'var(--color-666666)'}}>{t("CloudToast4")}</span>

                <Button
                    className='large-w-button button-solid-style button-min-width font-size-14 font-family-medium mt-20'
                    type="primary"
                    onClick={() => {
                        setIsShowDialog(false);
                    }}
                    style={{background:"var(--button-background-color)",width:'166px',alignSelf:'center'}}
                    htmlType={"submit"}>{t("Ok")}</Button>
            </div>
        </Modal>
    )
})

export default DialogOtherTip;